<script>
import { FAKE_ORDER_LIST } from '@src/config/fake-order'
import { orderRegStatusItem } from '@utils/zerone-order'

export default {
  components: {
    // DialogSession,
  },
  props: {
    orderList: {
      type: Array,
      default: () => {
        return FAKE_ORDER_LIST
      },
    },
  },
  computed: {
    routeName() {
      const route = () => {
        return {
          'member-activity-list': 'member-activity-item',
          'member-event-list': 'member-event-item',
        }
      }

      return route()[this.$route.name]
    },
  },
  methods: {
    statusItem(item) {
      return orderRegStatusItem(item)
    },
    brandTipTitle(orderItem) {
      return orderItem.brands.map((item) => item.title).join('<br>')
    },
  },
}
</script>
<template>
  <div :class="$style.OrderSession">
    <router-link
      v-for="(orderItem, index) in orderList"
      :key="index"
      :class="$style.courseSession"
      class=""
      :to="{
        name: routeName,
        params: {
          eventAlias: orderItem.alias,
          eventSeriesNum: orderItem.seriesNum,
        },
      }"
    >
      <div class="courseSession__time d-flex justify-content-between">
        <div class="align-self-center">
          {{ orderItem.dateTimeRange }}
          <el-tag :class="statusItem(orderItem.regStatus).class" class="d-xl-none">
            {{ statusItem(orderItem.regStatus).title }}
          </el-tag>
        </div>
        <div class="courseSession__action ml-3 d-xl-none text-right">
          <template v-if="orderItem.brands.length > 1">
            <el-tooltip placement="top">
              <div slot="content" v-html="brandTipTitle(orderItem)"></div>
              <div class="courseSession__action__brandsText"> 多品牌協辦 </div>
            </el-tooltip>
          </template>
          <template v-else>
            <img v-if="orderItem.brands[0].logo" :src="orderItem.brands[0].logo" :alt="orderItem.brands[0].alias" />
          </template>
        </div>
      </div>
      <div class="d-flex">
        <div class="courseSession__content">
          <el-tag v-if="orderItem.type === 'online'" class="isStylePrimary isOutline isAngle mr-3 d-xl-block d-none"> <i class="fas fa-circle fa-sm mr-2"></i>LIVE </el-tag>
          <div class="courseSession__text">
            <el-tag v-if="orderItem.type === 'online'" class="isStylePrimary isOutline isAngle mr-2 d-xl-none"> <i class="fas fa-circle fa-sm mr-2"></i>LIVE </el-tag>
            {{ orderItem.title }}
          </div>
        </div>
        <div class="ml-lg-auto d-xl-flex align-self-center d-xl-block d-none">
          <div class="align-self-xl-center courseSession__tag">
            <el-tag :class="statusItem(orderItem.regStatus).class">
              {{ statusItem(orderItem.regStatus).title }}
            </el-tag>
          </div>
          <div class="courseSession__action ml-xl-3">
            <template v-if="orderItem.brands.length > 1">
              <el-tooltip placement="top">
                <div slot="content" v-html="brandTipTitle(orderItem)"></div>
                <div class="courseSession__action__brandsText"> 多品牌協辦 </div>
              </el-tooltip>
            </template>
            <template v-else>
              <img v-if="orderItem.brands[0].logo" :src="orderItem.brands[0].logo" :alt="orderItem.brands[0].alias" class="d-none d-md-block" />
            </template>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<style lang="scss" module>
.OrderSession {
  .courseSession {
    // display: flex;
    // align-items: center;
    display: block;
    padding: 2.375rem 3.125rem;
    margin-bottom: 1.5rem;
    font-size: 1.25rem;
    background-color: #fff;
    border: transparent 1px solid;
    color: $color-gray-7;
    &:hover {
      text-decoration: none;
      :global {
        .courseSession__text {
          color: $color-primary;
        }
      }
    }
    @include max-md {
      padding: $container-gap;
    }
    &:global {
      &.disabled {
        .courseSession__text {
          color: $color-gray-5;
        }

        .courseSession__time {
          color: $color-gray-5;
        }
      }

      &.isApply {
      }

      &.isFinish {
        border-bottom: $color-gray-3 1px solid;
      }

      &.isActive {
        border: $color-primary 1px solid;
        .courseSession {
          &__text {
            color: $color-primary;
          }
        }
      }
    }

    :global {
      .courseSession {
        &__time {
          color: $color-gray-5;
          font-size: 1rem;
          @include max-md {
            font-size: 0.75rem;
            letter-spacing: 0.1em;
          }
        }

        &__text {
          margin-right: 2rem;
          // font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
          font-size: 1.25rem;
          @include max-lg {
            margin-right: 0;
          }
          @include max-md {
            font-size: 0.875rem;
          }
        }

        &__content {
          display: flex;
          align-items: center;
          margin-top: 10px;
          // @include max-lg {
          //   flex-direction: column;
          //   padding: 10px 0;
          // }
          @include max-lg {
            display: block;
          }
        }
        &__tag {
          width: 105px;
          text-align: center;
          @include max-md {
            text-align: left;
          }
        }
        &__action {
          // flex-shrink: 0;
          width: 130px;

          @include max-md {
            width: 90px;
            img {
              height: 30px;
            }
          }
          &__brandsText {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 130px;
            max-width: 130px;
            height: 32px;
            font-size: 14px !important;
            border-radius: 4px;
            line-height: 50px;
            color: $color-primary;
            border: 1px solid $color-primary;
            font-size: 1.125rem;
            @include max-md {
              width: 90px;
              height: 35px;
              font-size: 0.75rem;
              line-height: 35px;
            }
          }
        }
      }

      // .isStylePrimary {
      //   min-width: 128px;
      //   padding-top: 1rem;
      //   padding-bottom: 1rem;
      //   font-size: 1rem;
      // }
      .el-tag {
        width: 90px;
        text-align: center;
      }
    }
  }
}
</style>
